import { useMemo } from 'react';
import { DEFAULT_THEME_NAME, DEFAULT_COMPONENTS, DEFAULT_THEME, LIGHT_THEME, PRINT_THEME, UPLIFT_THEME } from '../../constants.js';
import { jsx } from 'react/jsx-runtime';
import { createThemes } from '../../utilities/createThemes.js';
import { PolarisVizContext } from '../../contexts/PolarisVizContext.js';

function PolarisVizProvider({
  children,
  defaultTheme = DEFAULT_THEME_NAME,
  themes,
  components,
  animated,
  onError
}) {
  const value = useMemo(() => {
    return {
      components: { ...DEFAULT_COMPONENTS,
        ...components
      },
      themes: createThemes({
        Default: DEFAULT_THEME,
        Light: LIGHT_THEME,
        Print: PRINT_THEME,
        Uplift: UPLIFT_THEME,
        ...themes
      }),
      animated,
      defaultTheme,
      onError
    };
  }, [themes, components, animated, defaultTheme, onError]);
  return /*#__PURE__*/jsx(PolarisVizContext.Provider, {
    value: value,
    children: children
  });
}

export { PolarisVizProvider };
